import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconFrequencySizeS from './IconFrequency_size_s';

const props: CreateIconArguments = {
  l: IconFrequencySizeS,
  m: IconFrequencySizeS,
  s: IconFrequencySizeS,
  xs: IconFrequencySizeS,
  name: 'IconFrequency',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
